import {
  getExperienceById,
  getExperiences,
} from "../../../../Redux/Selectors/experiencesSelectors";

export const getAllExperiences = (state) => {
  const { results } = state.pages.experiences.list;
  const experiences = getExperiences(state, results);
  return experiences;
};

export const getAllExperiencesIsFetching = (state) => {
  const { isFetching } = state.pages.experiences.list;
  return isFetching;
};

/**
 * El detalle de una experiencia, o `null` mientras no sea la que se pide.
 *
 * `data` guarda el id del último detalle traído, así que al navegar de una
 * experiencia a otra sin recargar sigue apuntando a la anterior hasta que la
 * respuesta nueva llega. Sin comparar el id, la pantalla nueva monta con los
 * datos de la vieja —`priceMode`, `capacityUsage`, precios— antes de que el
 * pedido salga siquiera: los efectos de los hijos corren antes que el del
 * contenedor que dispara el request.
 *
 * @param {Object} state
 * @param {String} [experienceId] cuál se está mirando; sin él se devuelve el
 * detalle que haya, que es el comportamiento histórico.
 * @returns {Object|null}
 */
export const getExperienceDetail = (state, experienceId) => {
  const { data } = state.pages.experiences.detail;

  if (experienceId && experienceId !== data) return null;

  const experience = getExperienceById(state, data);
  return experience;
};

export const getExperienceDetailIsFetching = (state) => {
  const { isFetching } = state.pages.experiences.detail;
  return isFetching;
};

export const getExperienceDetailError = (state) => {
  const { error } = state.pages.experiences.detail;
  return error;
};
